﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customSchemaModelList from './tpl/customSchemaModelList.html';
import View_CustomSchemaModelListItem from './customSchemaModelListItem';

export default Marionette.CollectionView.extend({
    tagName: 'customSchemaModelList',
    childViewContainer: '#customSchemaModelList',
    childView: View_CustomSchemaModelListItem,
    getTemplate: function () {
        return tpl_customSchemaModelList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function (child, ChildViewClass, childViewOptions) {
        var options = _.extend({ model: child }, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
